<span class="suite-info__guests-capacity tooltip_container">
  <ng-container *ngFor="let index of createArray(maxGuests > 20 ? 20 : maxGuests); let i = index">
    <ng-container *ngIf="adults">
      <i *ngIf="i >= +adults + +children" class="fa-regular fa-person-simple suite-info__guests-capacity-icon"></i>
      <i
        *ngIf="i < +adults + +children"
        class="fas fas-person-simple suite-info__guests-capacity-icon suite-info__guests-capacity-icon--enabled"
      ></i>
    </ng-container>
    <i *ngIf="!adults" class="fa-regular fa-person-simple suite-info__guests-capacity-icon"></i>
  </ng-container>
  <span class="tooltip__text tooltip__text--top">
    {{ 'pdp-guests-toolptip' | translate: { numOfGuests: maxGuests } }}
  </span>
</span>
